/* Refund policy page — copy-to-clipboard buttons.
   Labels and messages come from the section settings via data attributes,
   so all wording stays editable in the theme editor. */
(function () {
  'use strict';

  function init(root) {
    var scope = root || document;
    var buttons = scope.querySelectorAll('[data-rp-copy]');

    Array.prototype.forEach.call(buttons, function (btn) {
      if (btn.dataset.rpCopyReady === 'true') return;
      btn.dataset.rpCopyReady = 'true';

      var label = btn.querySelector('span');
      var status = btn.parentNode.querySelector('.rp-status');
      var source = document.getElementById(btn.getAttribute('data-rp-copy'));
      if (!source) return;

      var idleText = btn.getAttribute('data-rp-copy-label') || (label ? label.textContent : '');
      var doneText = btn.getAttribute('data-rp-copied-label') || idleText;
      var okText = btn.getAttribute('data-rp-copy-success') || '';
      var errText = btn.getAttribute('data-rp-copy-error') || '';
      var timer;

      function finish(ok) {
        if (status) status.textContent = ok ? okText : errText;
        if (ok && label) label.textContent = doneText;
        clearTimeout(timer);
        timer = setTimeout(function () {
          if (label) label.textContent = idleText;
          if (status) status.textContent = '';
        }, 2500);
      }

      function fallback(text) {
        var field = document.createElement('textarea');
        field.value = text;
        field.setAttribute('readonly', '');
        field.style.position = 'absolute';
        field.style.left = '-9999px';
        document.body.appendChild(field);
        field.select();
        var ok = false;
        try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
        document.body.removeChild(field);
        finish(ok);
      }

      btn.addEventListener('click', function () {
        var text = (source.innerText || source.textContent || '').trim();
        if (!text) { finish(false); return; }
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(text).then(function () { finish(true); }, function () { fallback(text); });
        } else {
          fallback(text);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Keep working while editing in the theme editor.
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:block:select', function (event) { init(event.target); });
})();
